import { render, staticRenderFns } from "./AppRefList.vue?vue&type=template&id=efb86a5a&"
import script from "./AppRefList.vue?vue&type=script&lang=js&"
export * from "./AppRefList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports